import { useLocalStorage } from 'usehooks-ts';
import { localStorageKeys } from '../../../lib/localstorageKeys';
import { Checkbox, CheckboxField } from '../../catalyst-ui-kit/checkbox';
import { Label } from '../../catalyst-ui-kit/fieldset';
import { Tooltip } from '../../Tooltip/Tooltip';

interface TradePreference {
  label: string;
  description?: string;
  selected: boolean;
  localstorageKey: string;
  onChange: React.Dispatch<React.SetStateAction<boolean>>;
}

const TradePanelUi: React.FC = () => {
  const [showConfirmOrderModal, setShowConfirmOrderModal] = useLocalStorage(
    localStorageKeys.showConfirmOrderModal,
    true
  );
  // const [showConfirmCloseModal, setShowConfirmCloseModal] = useLocalStorage(
  //   localStorageKeys.showConfirmCloseModal,
  //   true
  // );
  const [showCloseAllModal, setShowCloseAllModal] = useLocalStorage(
    localStorageKeys.showConfirmCloseAllModal,
    true
  );
  const [showCancelAllModal, setShowCancelAllModal] = useLocalStorage(
    localStorageKeys.showConfirmCancelAllModal,
    true
  );

  const [hidePnl, setHidePnl] = useLocalStorage(localStorageKeys.hidePnl, false); // default to show pnl
  // const [showTradeHistory, setShowTradeHistory] = useLocalStorage(
  //   localStorageKeys.showTradeHistory,
  //   true
  // );

  const [orderbookSetSizeOnClick, setOrderbookSetSizeOnClick] = useLocalStorage(
    localStorageKeys.orderbookSetSizeOnClick,
    false
  );

  const tradePreferences: Record<string, TradePreference[]> = {
    'Confirmation Settings': [
      {
        localstorageKey: localStorageKeys.showConfirmOrderModal,
        label: 'Show Confirm Order Modal',
        selected: showConfirmOrderModal,
        onChange: setShowConfirmOrderModal,
      },
      // {
      //   localstorageKey: localStorageKeys.showConfirmCloseModal,
      //   label: 'Show Confirm Close Modal',
      //   selected: showConfirmCloseModal,
      //   onChange: setShowConfirmCloseModal,
      // },
      {
        localstorageKey: localStorageKeys.showConfirmCloseAllModal,
        label: 'Show Confirm Close All Positions Modal',
        selected: showCloseAllModal,
        onChange: setShowCloseAllModal,
      },
      {
        localstorageKey: localStorageKeys.showConfirmCancelAllModal,
        label: 'Show Confirm Cancel All Orders Modal',
        selected: showCancelAllModal,
        onChange: setShowCancelAllModal,
      },
    ],
    'Display Settings': [
      {
        localstorageKey: localStorageKeys.hidePnl,
        label: 'Show P&L',
        selected: !hidePnl,
        onChange: setHidePnl,
      },
      // {
      //   localstorageKey: localStorageKeys.showTradeHistory,
      //   label: 'Show Trade History',
      //   selected: showTradeHistory,
      //   onChange: setShowTradeHistory,
      //   description:
      //     'By default, only the last 100 transactions within the past 7 days are displayed.',
      // },
      {
        localstorageKey: localStorageKeys.orderbookSetSizeOnClick,
        label: 'Order Book Set Size on Click',
        selected: orderbookSetSizeOnClick,
        onChange: setOrderbookSetSizeOnClick,
        description:
          'Clicking a level on the order book sets the limit price. When enabled, this setting also sets the order size.',
      },
    ],
  };

  const renderLabel = (label: string) => {
    return (
      <Label className="cursor-pointer !text-sm font-normal !text-contentPrimary transition-colors">
        {label}
      </Label>
    );
  };

  const renderPreference = (tradePreference: TradePreference) => {
    return (
      <div key={tradePreference.localstorageKey}>
        <CheckboxField>
          <Checkbox
            name={tradePreference.localstorageKey}
            checked={tradePreference.selected}
            onChange={() => tradePreference.onChange((prev) => !prev)}
            color="tertiary"
          />
          {tradePreference.description ? (
            <Tooltip content={tradePreference.description}>
              {renderLabel(tradePreference.label)}
            </Tooltip>
          ) : (
            renderLabel(tradePreference.label)
          )}
        </CheckboxField>
      </div>
    );
  };

  const renderSection = (sectionTitle: string, preferences: TradePreference[]) => {
    return (
      <div key={sectionTitle}>
        <h3 className="mb-3 text-xs text-contentSecondary">{sectionTitle}</h3>
        <div className="flex flex-col gap-3">{preferences.map(renderPreference)}</div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-4 sm:p-4">
      {Object.entries(tradePreferences).map(([title, preferences]) =>
        renderSection(title, preferences)
      )}
    </div>
  );
};

export const SettingsTradePanel: React.FC = () => {
  return <TradePanelUi />;
};
